import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import withAdminLayout from '../layout/withAdminLayout';
import Spinner from '../components/utilities/Spinner';
import RouteGate from '../components/utilities/RouteGate';

const Dashboard = lazy(() => import('../container/dashboard/Index1'));

const DashboardRoutes = () => {
    //const match = useMatch('/admin/profile/*'); // adjust to base route if different
    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spinner />
                </div>
            }
        >
            <RouteGate router="dashboard">
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="*" element={<Navigate to="/dashboard" />} />
                </Routes>
            </RouteGate>
        </Suspense>
    );
}

export default withAdminLayout(DashboardRoutes);
